import React, { useState, useCallback, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { useModal } from '../../../hooks/useModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import TutorialModalItem from './TutorialModalItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade, Navigation, Pagination } from 'swiper';

SwiperCore.use([EffectFade]);

export default function TutorialModal({ className, img, list, button, type }) {
  const { closeModal } = useModal();
  const [idModal, setIdModal] = useState(0);
  const [swiper, setSwiper] = useState();

  const extraButtonsProps = useMemo(() => list?.[idModal]?.button ?? {}, [idModal]);

  const onNext = useCallback(() => swiper && swiper.slideNext(), [swiper]);

  const items = list?.map((item, index) => {
    return (
      <SwiperSlide key={`TutorialModalItem-${index}`}>
        <TutorialModalItem {...item} index={index} />
      </SwiperSlide>
    );
  });

  const isLast = idModal === list.length - 1;

  const onTutorialComplete = useCallback(() => {
    closeModal('all');
  }, []);

  return (
    <CustomModal className={`custom-modal_tutorial`} animation={'fade'}>
      <div
        className={classNames('tutorial-modal', className, {
          ['tutorial-modal_image']: img,
          [`tutorial-modal_${type}`]: type,
        })}
      >
        {img && <img className={'tutorial-modal__image'} src={img} alt={'winners-img'} />}
        <div
          className={classNames('tutorial-modal__carousel', {
            'tutorial-modal__carousel_single': list?.length <= 1,
          })}
        >
          <Swiper
            modules={[Navigation, Pagination]}
            effect={'fade'}
            autoHeight={true}
            fadeEffect={{
              crossFade: true,
            }}
            pagination={{
              el: '.tutorial-modal__pagination',
            }}
            onSwiper={(swiper) => setSwiper(swiper)}
            onSlideChange={(swiper) => {
              setIdModal(swiper.realIndex);
              swiper.navigation.update();
            }}
          >
            {items}
          </Swiper>
          {list?.length > 1 && <div className='tutorial-modal__pagination' />}
        </div>
        <CustomButton onClick={() => (isLast ? onTutorialComplete : onNext)()} {...button} {...extraButtonsProps} />
      </div>
    </CustomModal>
  );
}
TutorialModal.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
